import React, {
  useState, useCallback,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Form,
  Label,
} from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import AppButton from 'components/App/Button';
import AppInputValidation from 'components/App/InputValidation';
import Authentication from 'components/App/Authentication';
import Meta from 'components/App/Meta';

import { LOCATIONS } from 'constants/index';
import { checkHadError, showSuccess } from 'utils';
import { createPassword } from 'utils/validate';

import styles from './CreatePassword.module.scss';

function CreatePassword(props) {
  const {
    isLoadingCreateAdministratorPassword,

    actionCreateAdministratorPassword,
  } = props;

  const [isShowPassword, setIsShowPassword] = useState(true);
  const [isShowConfirmPassword, setIsShowConfirmPassword] = useState(true);

  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('ref');

  const validation = useFormik({
    initialValues: {
      email: '',
      password: '',
      confirmPassword: '',
    },

    validationSchema: Yup.object({
      email: createPassword.email,
      password: createPassword.password,
      confirmPassword: createPassword.confirmPassword,
    }),

    onSubmit: (values) => {
      const callBackSuccess = () => {
        history.push(LOCATIONS.LOGIN);
        showSuccess('Vui lòng Đăng nhập với mật khẩu đã tạo');
      };

      actionCreateAdministratorPassword({
        result: values,
        token: encodeURIComponent(token.replace(/ /g, '+')),
        callBack: callBackSuccess,
      });
    },
  });

  const onToggleShow = useCallback((e) => {
    if (e.target.id === 'password') {
      setIsShowPassword((prevState) => !prevState);
    } else {
      setIsShowConfirmPassword((prevState) => !prevState);
    }
  }, []);

  return (
    <>
      <Meta name="Tạo Mật Khẩu" />

      <Authentication
        title="Xin chào!"
        description="Thiết lập mật khẩu để đăng nhập vào tài khoản quản trị viên"
      >
        <Form onSubmit={validation.handleSubmit} className={styles.Page}>
          <div className="Login__Email">
            <Label className="Login__Label">
              Email đăng nhập
              <code>*</code>
            </Label>

            <AppInputValidation
              inputClassName="Login__App-Input"
              placeholder="Nhập Email đăng nhập"
              name="email"
              validation={validation}
            />
          </div>

          <div className="Login__Password">
            <Label className="Login__Label">
              Mật khẩu
              <code>*</code>
            </Label>

            <AppInputValidation
              inputClassName="Login__App-Input"
              placeholder="Nhập mật khẩu"
              name="password"
              validation={validation}
              type={isShowPassword ? 'password' : 'text'}
            />

            <i
              id="password"
              className={`font-size-18 fas
                  ${checkHadError(validation, 'password') ? 'eye-error' : 'eye-default'}
                  ${!isShowPassword ? 'fa-eye-slash' : 'fa-eye'} cursor-pointer Login__Show-Pass-Icon
                  `}
              aria-hidden="true"
              onClick={onToggleShow}
            />
          </div>

          <div className="Login__ConfirmPassword">
            <Label className="Login__Label">
              Xác nhận lại mật khẩu
              <code>*</code>
            </Label>

            <AppInputValidation
              inputClassName="Login__App-Input"
              placeholder="Nhập lại mật khẩu"
              name="confirmPassword"
              validation={validation}
              type={isShowConfirmPassword ? 'password' : 'text'}
            />

            <i
              id="confirmPassword"
              className={`font-size-18 fas
                  ${checkHadError(validation, 'password') ? 'eye-error' : 'eye-default'}
                  ${!isShowConfirmPassword ? 'fa-eye-slash' : 'fa-eye'} cursor-pointer Login__Show-Pass-Icon
                  `}
              aria-hidden="true"
              onClick={onToggleShow}
            />
          </div>

          <AppButton
            classes="Login__Btn-Login"
            loading={isLoadingCreateAdministratorPassword}
            type="submit"
          >
            TẠO MẬT KHẨU
          </AppButton>
        </Form>
      </Authentication>
    </>
  );
}

CreatePassword.propTypes = {
  isLoadingCreateAdministratorPassword: PropTypes.bool.isRequired,

  actionCreateAdministratorPassword: PropTypes.func.isRequired,
};

CreatePassword.defaultProps = {
};

export default CreatePassword;
